import { render, staticRenderFns } from "./ObjectTableColumnConfig.vue?vue&type=template&id=348639f8&scoped=true"
import script from "./ObjectTableColumnConfig.vue?vue&type=script&lang=js"
export * from "./ObjectTableColumnConfig.vue?vue&type=script&lang=js"
import style0 from "./ObjectTableColumnConfig.vue?vue&type=style&index=0&id=348639f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348639f8",
  null
  
)

export default component.exports